module.exports = __webpack_public_path__ + "img/sector-icon.49808e06.svg";